export class CurrentModule {
  public static WORKFLOW = 'workflow';
  public static GED = 'ged';
}
